import CustomButton from "common/components/Button/Button"
import Modal from "common/components/Modal/Modal"
import { formatDate } from "common/utils/date"
import { useCallback, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { getPriceFormated } from "../../constants"

const ModalOmitirFactura = ({
  show,
  setShow,
  facturaInfo,
  handleConfirmOmitirFactura,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const onGetLabels = useCallback(
    () => [
      {
        label: `${t("documentos.facturaRec.idView.modal.labelCompanyName")}`,
        key: "razonSocial",
        className: "highlighted-box",
      },
      {
        label: `${t("documentos.facturaRec.idView.modal.labelInit")}`,
        key: "fechaInicio",
        format: formatDate,
        className: "",
      },
      {
        label: `${t("documentos.facturaRec.idView.modal.labelImport")}`,
        key: "importe",
        format: getPriceFormated,
        className: "highlighted-box",
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )
  const onRenderInfoBoxes = useMemo(() => {
    return onGetLabels().map((column) => {
      return (
        <div
          key={column.label}
          className='box_container'
        >
          <h6>{column.label}</h6>
          <p className={column.className}>
            {column.format
              ? column.format(facturaInfo[column.key])
              : facturaInfo[column.key]}
          </p>
        </div>
      )
    })
  }, [facturaInfo, onGetLabels])

  return (
    <Modal
      header={t("documentos.facturaRec.idView.modal.title")}
      visible={show}
      onHide={() => setShow(false)}
      size='small'
    >
      <div className='factura-recurrente_detail-container modal-omitir_container'>
        <div className='factura-detail_info-container'>{onRenderInfoBoxes}</div>
        <div className='factura-recurrente-modal__actions'>
          <p onClick={() => setShow(false)}>
            {t("documentos.facturaRec.idView.modal.cancelButton")}
          </p>
          <CustomButton
            type='text'
            className='ml-2 p-button-danger '
            onClick={() => handleConfirmOmitirFactura(facturaInfo)}
          >
            {t("documentos.facturaRec.idView.modal.acceptButton")}
          </CustomButton>
        </div>
      </div>
    </Modal>
  )
}

export default ModalOmitirFactura
